import { model as i18n } from '!/i18n'
import { register } from '!/repository'
import { genPagesLogicNew } from '@/effector'
import { nay, T } from '@/helpers'
import type { UiVodBundleWithContent } from '@/interfaces/vod'
import { api } from '@setplex/tria-api'
import { combine, createEvent, restore, sample, type Store } from 'effector'
import { not } from 'patronum'
import { model as movieModel } from '~/entities/movies'
import { model as paymentModel } from '~/features/payment/generic'
import { ssePurchasesModel } from '~/features/payment/sse-purchases'
import { formatVodBundleWithContentToUi } from './lib'

export const init = createEvent<{ bundleId: number }>()
export const left = createEvent()

/** Skeleton start*/
export const setContentLoading = createEvent<boolean>()

export const $contentLoading = restore(setContentLoading, false)

/** Skeleton end*/

sample({
  clock: init,
  filter: not(api.vodBundles.loadVodBundleWithContentFx.pending),
  fn: (clockData) => ({ ...clockData }),
  target: api.vodBundles.loadVodBundleWithContentFx,
})

/********** Skeleton logics starts ***********/

sample({
  clock: init,
  fn: T,
  target: setContentLoading,
})

sample({
  clock: api.vodBundles.loadVodBundleWithContentFx.pending,
  filter: nay,
  target: setContentLoading,
})

/********** Skeleton logics ends ***********/

const $vodBundleWithContentFormatted: Store<UiVodBundleWithContent | null> =
  combine(
    api.vodBundles.$vodBundleWithContent,
    ssePurchasesModel.$vod,
    ssePurchasesModel.$vodSet,
    i18n.$t,
    (vodBundle, adjustVod, adjustSet) =>
      formatVodBundleWithContentToUi(vodBundle, adjustVod, adjustSet)
  )

export const loadMoreVodBundleContent = genPagesLogicNew(
  api.vodBundles.$vodBundleWithContentPageInfo,
  api.vodBundles.paginateVodBundleWithContent
)

// clear paginatable stores
api.vodBundles.$vodBundleWithContent.reset(init)

register($vodBundleWithContentFormatted, '$vodBundleWithContentFormatted')
register(
  paymentModel.selectMovieBundlePaymentButton,
  'selectMovieBundlePaymentButton'
)
register(movieModel.updateVod, 'updateVod')
register(loadMoreVodBundleContent, 'loadMoreVodBundleContent')
